import { useAxios } from '@healthblocks-io/core'
import { useCallback } from 'react'

import { useAxiosAsync } from '@/@bothrs-react/hooks/useAxiosAsync'
import { buildAwellStatusUrl } from '../utils/awell.utils'

import type { AxiosResponse } from 'axios'

export type CreateAwellSession = {
  success_url: string
  cancel_url: string
  language: string
}

export type AwellSession = {
  activity_url?: string
  session_id: string
  session_url: string
  success: boolean
  language: string
}

function useQuestionnaireServices() {
  const axios = useAxios()

  const deleteActivity = useCallback(
    async (id: number) => {
      return axios.delete(`/careplan-activity/${id}`)
    },
    [axios],
  )

  const createAwellSession = useCallback(
    async (activityId: number): Promise<AxiosResponse<AwellSession>> => {
      return axios.post<AwellSession, AxiosResponse<AwellSession>, CreateAwellSession>(
        `/careplan-activity/${activityId}/awell-session`,
        {
          success_url: buildAwellStatusUrl('success'),
          cancel_url: buildAwellStatusUrl('cancelled'),
          language: 'nl',
        },
      )
    },
    [axios],
  )

  return {
    deleteActivity: useAxiosAsync(deleteActivity),
    createAwellSession,
  }
}

export { useQuestionnaireServices }
